import React, { Component } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import { formatTimeFrameReadable, formatDateForSummary } from '../../../helpers/formatting';

export class Scheduled extends Component {
	render() {
		const { inputData, business } = this.props;
		return (
			<div className="text-center">
				<h2 className="text-primary"><FaCheckCircle style={{ color: business?.cyberSettings?.foreground_color }}/></h2>
				<h5>Appointment Scheduled!</h5>
				<p>Thank you for scheduling your appointment. We look forward to seeing you {`${formatDateForSummary(inputData.invite.date)} ${formatTimeFrameReadable(inputData.invite.time, 'description')}`}</p>
			</div>
		);
	}
}

export default Scheduled;
